<template>
    <div class="site-manager-credential">
        <div v-if="loading">
            <br><br>
                Loading Network Credential
            <br><br>
        </div>
        <div v-else-if="!user.unit">
            Uh oh! We need to know your unit to grant you network access.
            <br><br>
            You can search for your unit by <a href="javascript://void(0)" @click="searchUnit">clicking here.</a>
            <br><br>
            If you cannot find your unit, contact resident support for assistance.<br>
            <a href="javascript://void" class="_chat-link">
                Live Chat Now
            </a>
            <br>
            Email:
            <a :href="'mailto:' + developerEmail">
                {{ developerEmail }}
            </a>
            <br>
            Text:
            <a :href="'sms:' + supportPhone + ';?&body=Hi,%20I%20have%20a%20question%20about%20the%20Bulk%20Program!'">
                {{ displaySupportPhone }}
            </a>
            <br>
            Call:
            <a :href="'tel:' + supportPhone + ',1'">
                {{displaySupportPhone}} option 1
            </a>
        </div>
        <div v-else-if="!user.resident || user.resident.deleted_at">
            Uh oh! We need to verify your resident account to grant you network access.
            Contact resident support for assistance.<br>
            <a href="javascript://void" class="_chat-link">
                Live Chat Now
            </a>
            <br>
            Email:
            <a :href="'mailto:' + developerEmail">
                {{ developerEmail }}
            </a>
            <br>
            Text:
            <a :href="'sms:' + supportPhone + ';?&body=Hi,%20I%20have%20a%20question%20about%20the%20Bulk%20Program!'">
                {{ displaySupportPhone }}
            </a>
            <br>
            Call:
            <a :href="'tel:' + supportPhone + ',1'">
                {{displaySupportPhone}} option 1
            </a>
        </div>
        <div v-else>
            <div v-if="credentialStatus">
                <span>
                    <b>Network Status:</b>
                    <span v-if="credentialStatus === 'Active'" style="color: #4CAF5D;"> <b>Active</b></span>
                    <span v-else-if="credentialStatus === 'Suspended'" style="color: #D80034;"> <b>Suspended</b></span>
                    <span v-else>{{ credentialStatus }}</span>
                    <br><br>
                    It looks like another resident at your unit is managing your credential.
                    If you believe this to be a mistake contact resident support at support@onboardtoday.com
                </span>
            </div>
            <div v-else>
                <div class="row">
                    <div class="col col-sm-10">
                        <p>
                            <b>Email:</b> {{ user.email }}<br>
                            <b>Service Activation:</b> {{ credentialDisplayActivationDate }}<br>
                            <b>Network Status:</b>
                            <span v-if="credentialDisplayStatus === 'Active'" style="color: green;"> <b>Active</b></span>
                            <span v-else-if="credentialDisplayStatus === 'Suspended'" style="color: red;"> <b>Suspended</b></span>
                            <span v-else>{{ credentialDisplayStatus }}</span>
                        </p>
                    </div>
                </div>

                <a href="javascript://void(0)" @click="confirmInviteEmail">Resend Network Invite Email</a>
                <br>
                <span v-if="isPending">Reset my pre-shared key (Network Invite hasn't been set up yet)</span>
                <a v-else href="javascript://void(0)" @click="confirmPskReset">Reset my pre-shared key</a>
                <br>
            </div>
        </div>
        <modal :name=modalId
            :adaptive="true"
            :scrollable="true"
            height="auto">
            <div class="dashboard-block" :class="{loading: modalLoading}">
                <div>
                    <header>
                        <h4>Are you sure?</h4>
                        <a href="javascript://void(0)" class="back" @click="closeModal">Close</a>
                    </header>
                    <div v-if="this.modalType === this.MODAL_RESEND_INVITE">
                        <p>
                            An email with instructions to set up network access will be sent to: <b>{{ user.email }}</b>
                        </p>
                        <button class="btn btn-sm btn-info" :disabled="modalLoading" @click="sendInviteEmail">Send</button>
                    </div>
                    <div v-else-if="this.modalType === this.MODAL_PSK_RESET">
                        <p>
                            An email with instructions to reset pre-shared key will be sent to: <b>{{ user.email }}</b>
                        </p>
                        <button class="btn btn-sm btn-info" :disabled="modalLoading" @click="sendPreSharedKey">Send</button>
                    </div>
                </div>
            </div>
        </modal>
    </div>
</template>

<script>
    const MODAL_RESEND_INVITE = 1;
    const MODAL_PSK_RESET = 2;

    export default {
        props: {
            modalId: {
                default(){
                    return _.uniqueId( 'modal_' );
                },
                type: String
            },
            user: {
                required: false,
                type: Object
            },
            appUrl: {
                required: true,
                type: String
            },
            developerEmail: {
                required: true,
                type: String
            },
            supportPhone: {
                required: true,
                type: String
            },
            displaySupportPhone: {
                required: true,
                type: String
            }
        },

        data() {
            return {
                MODAL_RESEND_INVITE,
                MODAL_PSK_RESET,
                loading: true,
                modalLoading: true,
                credential: null,
                credentialStatus: null,
                confirmation: false,
                modalType: MODAL_RESEND_INVITE,
            };
        },

        computed: {
            credentialDisplayActivationDate() {
                let activationDate = ' -';
                if (this.credential) {
                    let date = new Date(this.credential.activationDate);
                    activationDate = date.toLocaleDateString() + ' ' + this.formatTime(date);
                }
                return activationDate;
            },
            credentialDisplayStatus() {
                let status = null;
                if (this.credential && this.credential.smResident) {
                    status = this.credential.smResident.status;
                }
                return this.getDisplayStatus(status);
            },
            isPending() {
                return this.credential && this.credential.smResident && this.credential.smResident.status.includes('pending');
            },
            canSuspend() {
                return (
                    this.credential
                    && this.credential.smResident
                    && !this.credential.smResident.status.includes('pending')
                    && this.credential.smResident.status.includes('current')
                    && !this.credential.smResident.status.includes('disabled')
                );
            },
        },

        // If the resident is future, we pull the future credential,
        // If a credential exists, and we don't know if our resident is current or future,
        // We can show the credential & the email it is tied to
        // if we don't know, we pull the current active credential for the unit
        // PULL a list of ALL current or pending unit credentials
        mounted() {
            this.init();
        },

        methods: {
            init() {
                if (this.user.unit && this.user.resident) {
                    this.loadLeaseCredential()
                        .finally(res => {
                            this.loading = false;
                            this.modalLoading = false;
                        });
                }
                else {
                    this.loading = false;
                    this.modalLoading = false;
                }
            },

            loadLeaseCredential() {
                this.loading = true;
                this.modalLoading = true;
                var url = this.appUrl + '/tami/networkCredential';
                return axios.get(url)
                    .then(response => {
                        if (response.data.error) {
                            this.$notify( {
                                type: 'danger',
                                placement: 'top-left',
                                title: response.data.data
                            } );
                        }
                        else {
                            if (Array.isArray(response.data.data)) {
                                this.credential = null;
                                this.credentialStatus = this.getDisplayStatus(response.data.data);
                            }
                            else {
                                this.credentialStatus = null;
                                this.credential = response.data.data;
                            }
                        }
                    } )
                    .catch(err => {
                        if (err.response.data.error) {
                            this.$notify( {
                                type: 'danger',
                                placement: 'top-left',
                                title: err.response.data.data
                            } );
                        }
                        else {
                            this.$notify( {
                                type: 'danger',
                                placement: 'top-left',
                                title: 'Something went wrong loading network access information'
                            } );
                        }
                    })
                    .finally(() => {
                        this.loading = false;
                        this.modalLoading = false;
                        this.closeModal();
                    });
            },

            searchUnit() {
                window.location.href = "/user/unitSearch";
            },

            confirmInviteEmail() {
                this.modalType = this.MODAL_RESEND_INVITE;
                this.openModal();
            },

            confirmPskReset() {
                this.modalType = this.MODAL_PSK_RESET;
                this.openModal();
            },

            closeModal() {
                this.$modal.hide( this.modalId );
            },

            openModal() {
                this.$modal.show( this.modalId );
            },

            sendInviteEmail() {
                this.modalLoading = true;
                var url = this.appUrl + '/tami/networkCredential/invite';
                return axios.post(url)
                    .then(response => {
                        this.email = '';
                        this.$notify( {
                            type: 'success',
                            placement: 'top-left',
                            title: 'Network invite email sent successfully',
                        } );
                    } )
                    .catch(err => {
                        if (err.response.data.error) {
                            this.$notify( {
                                type: 'danger',
                                placement: 'top-left',
                                title: err.response.data.data
                            } );
                        }
                        else {
                            this.$notify( {
                                type: 'danger',
                                placement: 'top-left',
                                title: 'Something went wrong sending invite email. Refresh the page and try again.'
                            } );
                        }
                    })
                    .finally(() => {
                        this.modalLoading = false;
                        this.closeModal();
                    });
            },

            sendPreSharedKey() {
                this.modalLoading = true;
                var url = this.appUrl + '/tami/networkCredential/pskReset';
                return axios.post(url)
                    .then(response => {
                        this.$notify( {
                            type: 'success',
                            placement: 'top-left',
                            title: 'Pre-shared key reset email sent successfully',
                        } );
                    } )
                    .catch(err => {
                        if (err.response.data.error) {
                            this.$notify( {
                                type: 'danger',
                                placement: 'top-left',
                                title: err.response.data.data
                            } );
                        }
                        else {
                            this.$notify( {
                                type: 'danger',
                                placement: 'top-left',
                                title: 'Something went wrong sending psk reset email. Refresh the page and try again.'
                            } );
                        }
                    })
                    .finally(() => {
                        this.modalLoading = false;
                        this.closeModal();
                    });
            },

            // Helper functions / Computed values / etc
            formatTime(date) {
                let hours = date.getHours();
                let minutes = date.getMinutes();
                let ampm = hours >= 12 ? 'pm' : 'am';
                hours = hours % 12;
                hours = hours ? hours : 12;
                minutes = minutes.toString().padStart(2, '0');
                let strTime = hours + ':' + minutes + ampm;
                return strTime;
            },

            resetErrors() {
                this.error = {
                    activationDate: null,
                    email: null
                };
            },

            getDisplayStatus(s) {
                let status = ' -';
                if (s) {
                    if (s.includes('pending') && s.includes('current')) {
                        status = 'Pending';
                    }
                    else if (s.includes('disabled')) {
                        status = 'Suspended';
                    }
                    else if (s.includes('current')) {
                        status = 'Active';
                    }
                    else if (!s.includes('current')) {
                        status = 'Scheduled';
                    }
                }
                return status;
            }
        }
    }
</script>
